import { Space } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { type } from '../../utilities/constants';
import TableWithSorter from '../Common/TableWithSorter';

function TrainerTable(props) {
  const data = props.data;
  const columns = [
    {
      title: 'ID',
      dataIndex: 'trainerId',
      key: 'trainerId',
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/trainer/' + record.trainerId}>{record.trainerId}</Link>
        </Space>
      ),
      type: type.NUMBER,
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Is Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (text, record) => record.isActive.toString(),
    },
  ];
  return (
    <>
      <TableWithSorter
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        loading={props.loading}
        dataSource={data}
        columns={columns}
        pagination={{
          total: props.totalCount,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
        }}
        onChange={props.onPaginationChange}
      />
    </>
  );
}

export default TrainerTable;
